import { cashSecurity, propertySecurity } from '../constants'
/**
 *
 * @param isCash 'boolean  | null | undefined' value
 * @param isProperty 'boolean  | null | undefined' value
 * @returns string value -  "product types"
 */
export const getSecurityType = ({
  isCash,
  isProperty
}: {
  isCash: boolean | null | undefined
  isProperty: boolean | null | undefined
}): string => {
  if (isCash && isProperty) return `${cashSecurity}, ${propertySecurity}`
  if (isCash) return cashSecurity
  if (isProperty) return propertySecurity
  return ''
}
